import './scss/main.scss'
import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { setupHttp } from './services/http'
import { vCan } from './directives/can'
import stores from './stores'
import '@fortawesome/fontawesome-free/css/all.min.css'
import { useUserStore } from './stores/user'
import { startPresence, stopPresence } from './services/presence'
import { AuthApi } from './services/auth'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

app.use(stores)

setupHttp(pinia)

app.directive('can', vCan)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(router)

router.isReady().then(async () => {
  const user = useUserStore()
  if (user && user.isAuthenticated) {
    try {
      await AuthApi.reissue().catch(() => {})
      await user.fetchInitUserInfo()
      if (user.isAuthenticated) {
        startPresence()
      }
    } catch (e: any) {
      console.log(e)
    }
  }
  app.mount('#app')
})
window.addEventListener('beforeunload', () => {
  stopPresence()
})
